exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "canvas[data-v-4b13e41c]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b13e41c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/vue-components/market-data-chart.vue
// module id = 246
// module chunks = 0